// Vendors
import { useMemo, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Handlers
import { AuthWatcherFooterHandlers } from '../handlers/auth-watcher-footer.handlers';
// Types
import type { AuthWatcherFooterHookType } from './types/auth-watcher-footer.hook.type';
import type { AuthWatcherHookType } from 'providers/auth-watcher/hooks/types/auth-watcher.hook.type';

const useAuthWatcherFooterHook = (props: AuthWatcherHookType): AuthWatcherFooterHookType => {
  const [fetching, setFetching] = useState(false);

  const { showBoundary: setError } = useErrorBoundary();

  const { callbackUrl, loanId } = useAppContextConsumerHook();

  const { handleAuthWatcherModalMainButtonClick } = useMemo<
    ReturnType<typeof AuthWatcherFooterHandlers>
  >(() => AuthWatcherFooterHandlers({ ...props, callbackUrl, loanId, setFetching, setError }), []);

  return {
    fetching,
    handleAuthWatcherModalMainButtonClick,
  };
};

export { useAuthWatcherFooterHook };
